const API_BASE_URL = import.meta.env.VITE_API_URL ?? "https://ercole.top/filo";

export async function fetchLeaderboard() {
    const response = await fetch(`${API_BASE_URL}/leaderboard`);
    if (!response.ok) {
        throw new Error(`Errore ${response.status} nel caricamento della classifica.`);
    }

    const data = await response.json();
    if (!data.success) {
        throw new Error(data.error ?? "Errore nel caricamento della classifica.");
    }

    return data.leaderboard ?? [];
}

export async function submitScore(name, points) {
    const response = await fetch(`${API_BASE_URL}/score`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, points }),
    });

    const data = await response.json();
    if (!response.ok || !data.success) {
        throw new Error(data.error ?? `Errore ${response.status} nell'invio del punteggio.`);
    }

    return data.result;
}

export function qualifiesForTop10(score, leaderboard) {
    if (score <= 0) {
        return false;
    }
    if (leaderboard.length < 10) {
        return true;
    }

    const lastPlace = leaderboard[9];
    return score > lastPlace.points;
}

export function promptPlayerName() {
    return new Promise((resolve) => {
        const overlay = document.createElement("div");
        overlay.style.cssText = [
            "position:fixed",
            "inset:0",
            "display:flex",
            "align-items:center",
            "justify-content:center",
            "background:rgba(0,0,0,0.55)",
            "z-index:9999",
            "font-family:sans-serif",
        ].join(";");

        const panel = document.createElement("div");
        panel.style.cssText = [
            "background:#fff",
            "padding:24px 28px",
            "border-radius:12px",
            "text-align:center",
            "min-width:320px",
            "box-shadow:0 8px 32px rgba(0,0,0,0.25)",
        ].join(";");

        const title = document.createElement("p");
        title.textContent = "Sei in TOP 10!";
        title.style.cssText = "margin:0 0 8px;font-size:22px;font-weight:700;color:#111";

        const subtitle = document.createElement("p");
        subtitle.textContent = "Inserisci il tuo nome per entrare in classifica";
        subtitle.style.cssText = "margin:0 0 16px;font-size:14px;color:#444";

        const input = document.createElement("input");
        input.type = "text";
        input.maxLength = 64;
        input.placeholder = "Il tuo nome";
        input.style.cssText = [
            "width:100%",
            "box-sizing:border-box",
            "padding:10px 12px",
            "margin-bottom:12px",
            "border:2px solid #ccc",
            "border-radius:8px",
            "font-size:16px",
        ].join(";");

        const error = document.createElement("p");
        error.style.cssText = "margin:0 0 12px;font-size:13px;color:#c0392b;min-height:18px";

        const submitButton = document.createElement("button");
        submitButton.textContent = "Invia punteggio";
        submitButton.style.cssText = [
            "width:100%",
            "padding:10px 12px",
            "border:none",
            "border-radius:8px",
            "background:#4caf50",
            "color:#fff",
            "font-size:16px",
            "font-weight:700",
            "cursor:pointer",
        ].join(";");

        const skipButton = document.createElement("button");
        skipButton.textContent = "Ignora classifica";
        skipButton.style.cssText = [
            "width:100%",
            "padding:10px 12px",
            "border:2px solid #ccc",
            "border-radius:8px",
            "background:#f5f5f5",
            "color:#333",
            "font-size:16px",
            "font-weight:700",
            "cursor:pointer",
        ].join(";");

        const buttons = document.createElement("div");
        buttons.style.cssText = "display:flex;flex-direction:column;gap:8px";
        buttons.append(submitButton, skipButton);

        function cleanup() {
            overlay.remove();
            document.removeEventListener("keydown", onKeyDown);
        }

        function submit() {
            const name = input.value.trim();
            if (!name) {
                error.textContent = "Il nome non può essere vuoto.";
                input.focus();
                return;
            }
            cleanup();
            resolve(name);
        }

        function skip() {
            cleanup();
            resolve(null);
        }

        function onKeyDown(event) {
            if (event.key === "Enter") {
                submit();
            }
            if (event.key === "Escape") {
                skip();
            }
        }

        submitButton.addEventListener("click", submit);
        skipButton.addEventListener("click", skip);
        document.addEventListener("keydown", onKeyDown);

        panel.append(title, subtitle, input, error, buttons);
        overlay.append(panel);
        document.body.append(overlay);
        input.focus();
    });
}
